export default function ServicesSection() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-16">
          <div className="lg:w-1/2 mb-8 lg:mb-0">
            <p className="text-lime-500 text-sm font-bold mb-3 flex items-center">
              <span className="w-2 h-2 bg-lime-500 rounded-full mr-2"></span>
              OUR SOLUTIONS
            </p>
            <h2 className="text-5xl font-serif italic text-gray-900">
              Standard, Custom & GMA Pallets
            </h2>
          </div>
          <div className="lg:w-2/5">
            <p className="text-lg text-gray-600 leading-relaxed">
              When you need to <strong>Buy 48x40 Pallets Nationwide</strong>, <strong>Buy Custom Pallets Nationwide</strong>, or <strong>Buy GMA Pallets Nationwide</strong>, we deliver exceptional quality with fast turnaround times and competitive pricing across all 50 states.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-truck-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Buy 48x40 Pallets Nationwide</h3>
            <p className="text-gray-600 leading-relaxed">
              Industry-standard 48x40 pallets available for immediate delivery across the United States. Perfect for warehousing, shipping, and storage needs with consistent quality and durability.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-settings-3-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Buy Custom Pallets Nationwide</h3>
            <p className="text-gray-600 leading-relaxed">
              Tailored pallet solutions designed to meet your specific requirements. Custom sizes, materials, and configurations available with expert consultation and nationwide shipping.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-stack-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Buy Standard & GMA Pallets Nationwide</h3>
            <p className="text-gray-600 leading-relaxed">
              GMA-approved standard pallets meeting Grocery Manufacturers Association specifications. Reliable, consistent quality for retail, distribution, and logistics operations nationwide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}